function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Heading from '../../typography/Heading';
import { px2rem, mediaMinWidth } from '../../utils/helpers';
var StyledHeading = styled(Heading)(_templateObject(), function (_ref) {
  var _ref2;

  var theme = _ref.theme;
  var breakpoints = theme.breakpoints;
  return _ref2 = {}, _ref2[mediaMinWidth(breakpoints.medium)] = {
    lineHeight: px2rem(30)
  }, _ref2[mediaMinWidth(breakpoints.xlarge)] = {
    lineHeight: px2rem(32)
  }, _ref2;
});

function ModalHeading(_ref3) {
  var id = _ref3.id,
      children = _ref3.children;
  return /*#__PURE__*/React.createElement(StyledHeading, {
    forwardedAs: "h4",
    id: id
  }, children);
}

ModalHeading.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node.isRequired,
  id: PropTypes.string.isRequired
} : {};
export default ModalHeading;